// @ts-nocheck
// GENERATED from PropelMapper/design@b27d324 — do not edit.
import * as React from "react";
// PMDataTable.tsx — PropelMapper data table.
//
// Sortable columns, sticky header, optional clickable rows. Columns are
// configured objects; cells render a value or a custom `render(row)`. Sorts
// internally by default (string/number aware); pass `sort` + `onSortChange` to
// control it. All --pm-* tokens.

const PMTABLE_CSS = `
.pmtable{box-sizing:border-box;background:var(--pm-surface);border:1px solid var(--pm-border-card);border-radius:var(--pm-radius-xl,18px);box-shadow:var(--pm-shadow-card);overflow:hidden;font-family:var(--pm-font-sans)}
.pmtable-scroll{overflow:auto}
.pmtable-t{width:100%;border-collapse:collapse}
.pmtable-t th{text-align:left;font:var(--pm-label-m);font-weight:700;color:var(--pm-fg-2);padding:13px 14px;border-bottom:1px solid var(--pm-border);background:linear-gradient(180deg,var(--pm-surface-secondary),var(--pm-surface));position:sticky;top:0;z-index:1;white-space:nowrap;user-select:none}
.pmtable-t th.is-sortable{cursor:pointer}
.pmtable-t th.is-sortable:hover{color:var(--pm-fg-1)}
.pmtable-th-in{display:inline-flex;align-items:center;gap:5px}
.pmtable-sortic{width:15px;height:15px;opacity:0;color:var(--pm-primary);transition:.12s}
.pmtable-t th.is-sorted .pmtable-sortic{opacity:1}
.pmtable-sortic svg{width:100%;height:100%;display:block}
.pmtable-t td{padding:12px 14px;border-bottom:1px solid var(--pm-border-light);font:var(--pm-body-m);color:var(--pm-fg-1);vertical-align:middle}
.pmtable-t tbody tr:last-child td{border-bottom:none}
.pmtable-t tbody tr.is-clickable{cursor:pointer;transition:background .1s}
.pmtable-t tbody tr.is-clickable:hover{background:var(--pm-primary-surface)}
.pmtable-num{text-align:right;font-variant-numeric:tabular-nums}
.pmtable-empty{padding:40px 16px;text-align:center;color:var(--pm-fg-3);font:var(--pm-body-m)}
`;
function pmtableEnsureCSS() {
  if (typeof document === "undefined" || document.getElementById("pmtable-css")) return;
  const s = document.createElement("style"); s.id = "pmtable-css"; s.textContent = PMTABLE_CSS;
  document.head.appendChild(s);
}

function pmtableSortIcon(dir) {
  const d = dir === "desc"
    ? "M7 10l5 5 5-5"
    : "M7 14l5-5 5 5";
  return <span className="pmtable-sortic" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none"><path d={d} stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg></span>;
}

export function PMDataTable({
  columns = [],
  rows = [],
  sort,
  onSortChange,
  rowKey,
  onRowClick,
  maxHeight = 460,
  emptyText = "No rows",
  className = "",
  style = {},
  ...rest
}) {
  pmtableEnsureCSS();
  const [internal, setInternal] = React.useState(sort || null);
  const active = sort !== undefined ? sort : internal;

  const setSort = (key) => {
    const dir = active && active.key === key && active.dir === "asc" ? "desc" : "asc";
    const next = { key, dir };
    if (onSortChange) onSortChange(next);
    if (sort === undefined) setInternal(next);
  };

  let view = rows;
  if (active && active.key) {
    const col = columns.filter((c) => c.key === active.key)[0];
    const get = (col && col.sortValue) ? col.sortValue : (r) => r[active.key];
    view = rows.slice().sort((a, b) => {
      const av = get(a), bv = get(b);
      let cmp;
      if (typeof av === "number" && typeof bv === "number") cmp = av - bv;
      else cmp = String(av == null ? "" : av).localeCompare(String(bv == null ? "" : bv), undefined, { numeric: true });
      return active.dir === "desc" ? -cmp : cmp;
    });
  }

  return (
    <div className={"pmtable" + (className ? " " + className : "")} style={style} {...rest}>
      <div className="pmtable-scroll" style={{ maxHeight }}>
        <table className="pmtable-t">
          <thead>
            <tr>
              {columns.map((c) => {
                const sorted = active && active.key === c.key;
                const isNum = c.align === "right";
                return (
                  <th key={c.key}
                    className={(c.sortable ? "is-sortable" : "") + (sorted ? " is-sorted" : "") + (isNum ? " pmtable-num" : "")}
                    style={c.width ? { width: c.width } : undefined}
                    onClick={c.sortable ? () => setSort(c.key) : undefined}>
                    <span className="pmtable-th-in">{c.label}{c.sortable ? pmtableSortIcon(sorted ? active.dir : "asc") : null}</span>
                  </th>
                );
              })}
            </tr>
          </thead>
          <tbody>
            {view.length ? view.map((r, i) => (
              <tr key={rowKey ? r[rowKey] : i}
                className={onRowClick ? "is-clickable" : ""}
                onClick={onRowClick ? () => onRowClick(r) : undefined}>
                {columns.map((c) => (
                  <td key={c.key} className={c.align === "right" ? "pmtable-num" : ""} style={c.align === "center" ? { textAlign: "center" } : undefined}>
                    {c.render ? c.render(r) : r[c.key]}
                  </td>
                ))}
              </tr>
            )) : (
              <tr><td className="pmtable-empty" colSpan={columns.length}>{emptyText}</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
